import React from 'react';
import * as S from '../Styles';

type ScrollDirection = 'left' | 'right';

interface ScrollButtonProps {
  direction: ScrollDirection;
  onClick: () => void;
  isDisabled: boolean;
}

export const ScrollButton: React.FC<ScrollButtonProps> = ({ direction, onClick, isDisabled }) =>
  direction === 'left' ? (
    <S.StyledArrowLeft
      icon="arrow-left"
      variant="secondary"
      ariaLabel="pil venstre"
      onClick={onClick}
      disabled={isDisabled}
    />
  ) : (
    <S.StyledArrowRight
      icon="arrow-right"
      variant="secondary"
      ariaLabel="pil høyre"
      onClick={onClick}
      disabled={isDisabled}
    />
  );
